import { IconProps } from './IconProps';

export const CheckOverCircle = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 7.70286C14 11.5562 10.856 14.7002 6.99728 14.7002C3.14395 14.7002 0 11.5562 0 7.70286C0 3.84414 3.14395 0.700195 6.99728 0.700195C10.856 0.700195 14 3.84414 14 7.70286ZM9.31359 4.9405L6.20728 9.87946L4.65949 7.94473C4.51438 7.75663 4.38003 7.69747 4.21343 7.69747C3.94472 7.69747 3.73512 7.91782 3.73512 8.18655C3.73512 8.32093 3.78886 8.45527 3.88022 8.57348L5.71287 10.7877C5.86872 10.9865 6.02458 11.0726 6.2288 11.0726C6.43303 11.0726 6.59961 10.9758 6.72321 10.7877L10.0929 5.50479C10.1627 5.39193 10.2326 5.2522 10.2326 5.12322C10.2326 4.84913 9.99616 4.66641 9.73817 4.66641C9.57693 4.66641 9.42107 4.76314 9.31359 4.9405Z"
        fill={props.fill ?? 'rgba(0,0,0,0.9)'}
      />
    </svg>
  );
};

